<template>
  <div class="b-item__delete" @click="debounce(delItem)" title="Удалить из корзины"></div>
</template>

<script>
import {mapActions} from 'vuex';
import errors from "@/components/mixins/errors";
import tools from "@/components/mixins/tools";

export default {
  props: ['bid'],
  name: "BasketDelBtn",
  mixins: [errors, tools],
  methods: {
    ...mapActions([
      'REMOVE_BASKET_ITEM', 'SET_QUANTITY'
    ]),
    delItem() {
      this.SET_QUANTITY({bid: this.bid, quantity: 0});
      this.REMOVE_BASKET_ITEM(this.bid)
    },
  },

}
</script>

<style scoped>

</style>